<template>
  <div class="flex-right">
    <input style="display:none" type="file" ref="importInput" @change="loadImportFile" accept="application/json">

    <v-tooltip bottom :disabled="!desactiveImport">
      <template #activator="{ on }">
        <div v-on="on" style="display: inline;">
          <v-btn :disabled="!!desactiveImport" color='primary' @click="openImporting" text v-text="$t('core.import_export.import')" />
        </div>
      </template>
      <span>{{ desactiveImport }}</span>
    </v-tooltip>
    /
    <v-tooltip bottom :disabled="!desactiveExport">
      <template #activator="{ on }">
        <div v-on="on" style="display: inline;">
          <v-btn :disabled="!!desactiveExport" color='primary' @click="openExporting" text v-text="$t('core.import_export.export')" />
        </div>
      </template>
      <span>{{ desactiveExport }}</span>
    </v-tooltip>

    <CDialog v-model="showDialog" persistent>
      <template #header> {{ fullTitle }} </template>
      <template #body>

        <v-form ref="form">
          <v-data-table
            v-model="itemsSelected"
            :headers="headers"
            :items="items"
            item-key="id"
            selectable-key="selectable"
            class="elevation-1"
            disable-pagination
            hide-default-footer
            show-select
          >

            <!-- Slots binding -->
            <template v-for="slotName in slotsNames" #[slotName]="props">
              <slot :name="slotName" v-bind="props"></slot>
            </template>

          </v-data-table>
        </v-form>

      </template>
      <template #footer>
        <v-spacer />
        <v-btn color="#6419a5" outlined @click="endOperation">{{ $t('button.cancel') }}</v-btn>
        <v-btn color="primary" @click="finalizeOperation" :disabled="itemsSelected.length == 0">{{ endOperationText }}</v-btn>
      </template>
    </CDialog>
  </div>
</template>

<script>
import CDialog from './CDialog.vue'
import ImportExportService from '@/services/ImportExportService'
import DownloadService from '@/services/DownloadService'

export default {
  name: 'ImportExport',

  components: { CDialog },

  props: {
    headers: Array,
    title: String,
    type: String,
    params: Object,
    desactiveImport: String,
    desactiveExport: String
  },

  data: () => ({
    isExporting: false,
    showDialog: false,
    itemsSelected: [],
    importFile: null,
    items: []
  }),

  computed: {
    endOperationText () { return this.isExporting ? this.$t('core.import_export.export') : this.$t('core.import_export.import') },
    fullTitle () {
      return this.isExporting
        ? `${this.$t('core.import_export.exporting')} ${this.title}`
        : `${this.$t('core.import_export.importing')} ${this.title}`
    },
    slotsNames () {
      return [...Object.keys(this.$slots), ...Object.keys(this.$scopedSlots)]
    }
  },

  methods: {
    openImporting () {
      const input = this.$refs.importInput
      input.click()
    },
    async loadImportFile ({ target }) {
      if (target.files.length !== 1) { target.value = ''; return }
      const file = target.files[0]
      target.value = ''

      const json = await new Blob([file]).text()
      const parsed = JSON.parse(json)
      this.items = Array.isArray(parsed) ? parsed : [parsed]
      this.items.forEach((e, i) => { e.id = i })
      this.showDialog = true
      this.isExporting = false
    },
    async openExporting () {
      try {
        const { data } = await ImportExportService.exportAll(this.type, this.params)
        const json = await new Blob([data]).text()
        this.items = JSON.parse(json)
        this.items.forEach((e, i) => { e.id = i })
        this.showDialog = true
        this.isExporting = true
      } catch (error) {
        this.$message.error(`${this.$t('warnings.error.export_all')} : ${error}`)
      }
    },
    endOperation () {
      this.showDialog = false
      this.items = []
      this.itemsSelected = []
    },
    async finalizeOperation () {
      if (!this.$refs.form.validate()) return
      const blob = new Blob([JSON.stringify(this.itemsSelected)], { type: 'application/json' })

      try {
        if (this.isExporting) await DownloadService.downloadContent(this.type, blob)
        else await ImportExportService.importAll(this.type, blob)

        if (this.isExporting) this.$message.success(this.$t('warnings.success.export_all'))
        else this.$message.success(this.$t('warnings.success.import'))

        this.endOperation()

        if (this.isExporting) this.$emit('export')
        else this.$emit('import')
      } catch (error) {
        if (this.isExporting) this.$message.error(`${this.$t('warnings.error.export_all')} : ${error}`)
        else this.$message.error(`${this.$t('warnings.error.import')} : ${error}`)
      }
    }
  }
}
</script>

<style>
@media (orientation: landscape) {
  .v-dialog {
    min-width: 33%;
    max-width: 65%;
    max-height: 90% !important;
    margin: auto !important;
  }
}
</style>
